import { IFieldDefinition } from "@entaconsulting/form";

/**
 * It iterates the schema definition and builds an object that implements that
 * definition, for example:
 *   given schemaDefinition = {
 *        "Domicilio" : {
 *           "type": "text"
 *        },
 *        "IIBB": {
 *           "type": "fieldGroup",
 *           "schema": {
 *              "Inscripto": {
 *                 "type": "boolean"
 *              }
 *           }
 *        }
 *      }
 *   then schemaObject = {
 *          Domicilio: Partial<IFieldDefinition>,
 *          IIBB: {
 *            "Inscripto": Partial<IFieldDefinition>
 *          }
 *        }
 *
 * While iterating the schemaDefinition it also builds a layoutSuggestionssObject.
 * This object is a list of strings that contains all the props in the schemaDefinition
 * object in all posible levels.
 *   given the same schemaDefinition object above
 *   then layoutSuggestionsObject: [ "Domicilio", "IIBB.Inscripto" ]
 */
const generateSchemaObject = (
  suggestionPrefix: string,
  schemaDefinition: any
) => {
  const schemaObject: Record<string, Partial<IFieldDefinition>> = {};
  let layoutSuggestionsObject: string[] = [];

  for (const name in schemaDefinition) {
    const type = schemaDefinition[name].type;
    if (type === "fieldGroup" || type === "list") {
      const {
        schemaObject: subSchemaObject,
        layoutSuggestionsObject: subLayoutSuggestionsObject,
      } = generateSchemaObject(
        suggestionPrefix === "" ? name : `${suggestionPrefix}[${name}]`,
        schemaDefinition[name].schema
      );
      schemaObject[name] = subSchemaObject;
      layoutSuggestionsObject = [
        ...layoutSuggestionsObject,
        ...subLayoutSuggestionsObject,
      ];
    } else {
      if (suggestionPrefix === "") {
        layoutSuggestionsObject.push(name);
      } else {
        layoutSuggestionsObject.push(`${suggestionPrefix}[${name}]`);
      }
      schemaObject[name] = { type: schemaDefinition[name].type };
    }
  }

  return { schemaObject, layoutSuggestionsObject };
};

export default generateSchemaObject;
